import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthCallbackComponent } from './auth-callback/auth-callback.component';

const routes: Routes = [
  { path: 'auth-callback', component: AuthCallbackComponent },
  {
    path: 'prescriptor',
    loadChildren: () => import('./prescriptor/prescriptor.module').then((m) => m.PrescriptorModule)
  },
  {
    path: 'lead',
    loadChildren: () => import('./lead/lead.module').then((m) => m.LeadModule)
  },
  {
    path: 'agent',
    loadChildren: () => import('./agent/agent.module').then((m) => m.AgentModule)
  },
  {
    path: 'liquidation',
    loadChildren: () => import('./liquidation/liquidation.module').then((m) => m.LiquidationModule)
  },
  {
    path: 'menu',
    loadChildren: () => import('./menuedit/menuedit.module').then((m) => m.MenuModule)
  },
  {
    path: 'roles',
    loadChildren: () => import('./roles/roles.module').then((m) => m.RolesModule)
  },
  {
    path: 'user-roles',
    loadChildren: () => import('./user-roles-admin/user-roles-admin.module').then((m) => m.UserRolesAdminModule)
  },
  {
    path: '',
    loadChildren: () => import('./home/home.module').then((m) => m.HomeModule)
  },
  { path: '**', redirectTo: '', pathMatch: 'full' }
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
